import { useWindowSize } from './useWindowSize'
import { Size } from 'types/size'

export const useVisibleItemsInWindow = (itemSize: Size) => {
  const windowSize = useWindowSize()

  const totalVisibleItems = countVisibleItemsInContainer(itemSize, windowSize)

  return totalVisibleItems
}

export const countVisibleItemsInContainer = (
  itemSize: Size,
  containerSize: Size
) => {
  const itemsVisibleHorizontally = Math.floor(
    containerSize.width / itemSize.width
  )
  const itemsVisibleVertically = Math.floor(
    containerSize.height / itemSize.height
  )

  const totalItemsVisible = itemsVisibleHorizontally * itemsVisibleVertically
  return totalItemsVisible
}
